import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.array.splice";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage } from "@/mixins/index";
import { accountDurations, accountDurationsSetver } from "@/api/dataAll/onlineDuration";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import * as echarts from "echarts";
export default {
  name: "onlineDuration",
  mixins: [tabulation, gmToolNewPage],
  data: function data() {
    return {
      more: true,
      value2: [],
      tableData: [],
      searchData: {
        is_new_register: ''
      },
      dates: [],
      datas: [],
      series: [],
      Dynamic: [],
      selectedArr: {},
      isServer: false,
      serverLists: []
    };
  },
  created: function created() {
    var _this = this;

    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    this.$nextTick(function () {
      _this.getServerLists();
    });
  },
  methods: {
    // 获取服务器列表
    getServerLists: function getServerLists() {
      var _this2 = this;

      accountDurationsSetver(this.searchData).then(function (res) {
        if (res.status == 200) {
          var list = [];
          res.data.map(function (i) {
            list.push({
              label: i,
              value: i
            });
          });
          _this2.serverLists = list;
        }
      });
    },
    getServerList: function getServerList() {
      var _this3 = this;

      var env_id = this.searchData.env_id;
      yjServerList({
        server_channel: this.server_channel,
        show_test: this.show_test,
        env_id: env_id
      }).then(function (res) {
        if (res.code == 200) {
          _this3.serverListYJ = res.data;
        }
      });
    },
    searchClicknew: function searchClicknew() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var queue, dates, datesList, i, _list, list, _i, qd;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.reqLoading = true;
                queue = [];
                dates = _this4.$times.getDayAll(_this4.value2[0], _this4.value2[1]);
                datesList = [];

                for (i = 0; i < dates.length; i += 10) {
                  _list = dates.slice(i, i + 10);
                  datesList.push({
                    starttime: _list[0],
                    endtime: _list[_list.length - 1]
                  });
                } // datesList.forEach(i => {
                //   queue.push(accountDurations({ ...this.searchData, ...i }))
                // })


                list = [];
                _i = 0;

              case 7:
                if (!(_i < datesList.length)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 10;
                return accountDurations(_objectSpread(_objectSpread({}, _this4.searchData), datesList[_i]));

              case 10:
                qd = _context.sent;

                if (qd.status == 200) {
                  list.push(qd);

                  _this4.searchClick(list);
                }

              case 12:
                _i++;
                _context.next = 7;
                break;

              case 15:
                _this4.reqLoading = false; // return await Promise.resolve(list)

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(res) {
      var _this5 = this;

      var newDatas = {
        data: {},
        date: []
      };
      res.forEach(function (i) {
        newDatas.data = _objectSpread(_objectSpread({}, newDatas.data), i.data.data);
        newDatas.date = [].concat(_toConsumableArray(newDatas.date), _toConsumableArray(i.data.date));
      });
      var newData = JSON.parse(JSON.stringify(newDatas.data));
      this.dates = [];
      this.datas = [];
      this.series = [];
      var columns = [{
        label: this.$t('gameDuration'),
        prop: 'length'
      }];
      var data = [];
      var num = 0;
      var knum = 0;

      for (var i in newData) {
        if (this.searchData.is_new_register == 1) {
          delete newData[i]['activity'];
        }

        if (this.searchData.is_new_register == 2) {
          delete newData[i]['register'];
        }

        this.dates.push(i);
        num += 1;
        columns.push({
          label: i,
          prop: num + 'Number'
        });
        var obj = {
          name: i,
          type: "bar",
          data: [],
          smooth: true
        };

        for (var k in newData[i]) {
          knum += 1;

          if (k != 'activity' || k != 'register') {
            this.datas.push(k);
          }

          data.push({
            length: k == 'activity' ? this.$t('activeAvgOnlineMinutes') : k == 'register' ? this.$t('newAvgOnlineMinutes') : k
          });
          data[knum - 1][num + 'Number'] = newData[i][k];
          obj.data.push(newData[i][k]);

          if (knum == (this.searchData.is_new_register ? 14 : 15)) {
            knum = 0;
          }
        }

        this.series.push(obj);
      }

      data.splice(this.searchData.is_new_register ? 14 : 15, data.length - (this.searchData.is_new_register ? 14 : 15));
      this.datas.splice(13, this.datas.length - 13);
      this.tableData = data;
      this.Dynamic = columns;
      this.getechart();
      this.$nextTick(function () {
        _this5.getTableRight();
      });
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("onlineDurationEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('accountOnlineDurationHours')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          // 这里显示点击搜索的日期--图表的最上面
          width: '80%' // selected: this.selectedArr,

        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.datas
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      this.$export.excel({
        columns: this.Dynamic,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};